<template lang="html">
  <section class="demo">

    <div style="width: 100%; display: flex; flex-direction: column">
      <h4>Logging In</h4>

      <ol class="Vlt-list Vlt-list--simple">
        <li>
          <div>Fill in your Mobile Number which you can receive the OTP.</div>
          <div><span style="font-style: italic;">Note: It does not have to be the same phone that has the app installed.</span></div>
        </li>
        <li>
          <div>Select the Data Center you want to be using.</div>
          <div><span style="font-style: italic;">Note: Each data center has its own set of users, and they cannot cross-communicate.</span></div>
          <img src="https://vids.vonage.com/pages/inapp-android/image2.jpg" width="240" alt="image2" />
        </li>
        <li>
          <span>Click on&nbsp;</span>
          <span style="padding-left: 4px; padding-right: 4px; background-color: #e6e6e6">Login</span>
          <span>.</span>
        </li>
        <li>
          <div>You will be presented with the OTP page.</div>
          <div>Fill in the OTP that you receive on the mobile number you provided.</div>
          <img src="https://vids.vonage.com/pages/inapp-android/image3.jpg" width="240" alt="image3" />
        </li>
      </ol>

      <div style="font-style: italic; color: #ff0000; margin-bottom: 16px;">
        Warning: If you accidentally close the app, or leave this screen, the OTP (Nexmo Verify) will still be sent, but nowhere to verify from. This may cause the SMS/Voice OTP calls to continue to happen until it expires, as per default Nexmo Verify behaviour. Do note also that you cannot request for another OTP before the current OTP expires.
      </div>


    </div>

  </section>

</template>

<script lang="js">
  export default  {
    name: 'demo',
    components: {
    },
    props: {
      nexmo:{
          type: Object,
          required: false
      }
    },
}
</script>

<style scoped lang="scss">
</style>